import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import { useBack } from '@/hooks/useBack'

const UpdateUniformPageHeader = () => {
  const { t } = useTranslation()
  const handleBack = useBack()
  return (
    <Space>
      <Button onClick={handleBack} icon={<ArrowLeftOutlined />}>
        {t('components.pages.admins.update.pageHeader.back')}
      </Button>
      <PageHeader ghost={false} title={t('components.pages.admins.create.pageHeader.title')} />
    </Space>
  )
}

UpdateUniformPageHeader.displayName = 'UpdateUniformPageHeader'
export default UpdateUniformPageHeader
